export const SAVE_CRITERIA_TAB = 'SAVE_CRITERIA_TAB';
export const SAVE_MULTISTUDENT_TAB = 'SAVE_MULTISTUDENT_TAB';
export const SAVE_REPORT_TAB = 'SAVE_REPORT_TAB';
export const RESET_GRADECARD_MODULE_DATA = "RESET_GRADECARD_MODULE_DATA";